import { EventComponent, PartKey, PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { ComponentIds, PartPair, ProductCatalogFunctions, ReplaceAssemblyPartUtils } from '@inter-ikea-core/core';
import BestaFrameComponent from '../components/BestaFrameComponent';
import OngoingAssemblyUpdateComponent from '../components/OngoingAssemblyUpdateComponent';
export class MatchDrawerColorSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'MatchDrawerColorSystem', EventComponent.id);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            newComponent.event === 'history') {
            this.replaceDrawers();
        }
    }
    onRemove() { }
    replaceParts(target, parts, createCheckpoint) {
        if (createCheckpoint) {
            ReplaceAssemblyPartUtils.replaceProductParts(target, parts, this.coreApi.getServices());
        }
        else {
            const currentParts = ProductCatalogFunctions.createAssemblyParts(target, [], true);
            let updated = false;
            const newParts = currentParts.map((currentPart) => {
                const newPart = parts.find(part => part.partKey === currentPart.partKey);
                if (newPart && newPart.productRef !== currentPart.productRef) {
                    updated = true;
                    return newPart;
                }
                else {
                    return currentPart;
                }
            });
            if (updated) {
                target.addComponent(new OngoingAssemblyUpdateComponent());
                ReplaceAssemblyPartUtils.replaceProductParts(target, newParts, this.coreApi.getServices());
                target.removeComponent(OngoingAssemblyUpdateComponent.id);
            }
        }
        return null;
    }
    /**
     * Replace drawer body based on parent frame color
     */
    replaceDrawers() {
        const drawerAssemblies = this.coreApi.entities.getByComponent(ComponentIds.DRAWER_COMPONENT_ID);
        drawerAssemblies.forEach(drawer => {
            const frame = drawer.getComponent(ComponentIds.CHILD_COMPONENT_ID)?.parent;
            if (!frame) {
                return;
            }
            const frameAssembly = frame.getComponent(ComponentIds.CHILD_COMPONENT_ID)
                ?.parent;
            const validDrawers = frameAssembly?.getComponent(BestaFrameComponent.id)
                ?.validDrawers;
            if (!validDrawers)
                return;
            const drawerSize = drawer.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
            const newBodyProductRef = drawerSize && drawerSize.height >= 380 ? validDrawers.high : validDrawers.low;
            if (newBodyProductRef) {
                this.replaceParts(drawer, [new PartPair(PartKey.DRAWER_ASSEMBLY_BODY, newBodyProductRef)]);
            }
        });
    }
}
//# sourceMappingURL=MatchDrawerColorSystem.js.map